import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("rent_cookie_consent")) setShow(true);
  }, []);
  if (!show) return null;
  const decide = (v) => {
    localStorage.setItem("rent_cookie_consent", v);
    setShow(false);
  };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4">
      <div className="max-w-3xl mx-auto bg-card border border-border rounded-xl shadow-lg p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-testid="cookie-banner">
        <p className="text-sm text-muted-foreground flex-1">
          Rent utilise uniquement des cookies strictement nécessaires au fonctionnement (authentification). Aucun traceur
          publicitaire. Détails dans notre{" "}
          <Link to="/confidentialite" className="underline text-foreground">politique de confidentialité</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" className="rounded-full" onClick={() => decide("refused")} data-testid="cookie-refuse">Refuser</Button>
          <Button className="rounded-full" onClick={() => decide("accepted")} data-testid="cookie-accept">Accepter</Button>
        </div>
      </div>
    </div>
  );
}
